import { render, staticRenderFns } from "./DocumentsContent.vue?vue&type=template&id=68e0a424&scoped=true"
import script from "./DocumentsContent.vue?vue&type=script&lang=js"
export * from "./DocumentsContent.vue?vue&type=script&lang=js"
import style0 from "./DocumentsContent.vue?vue&type=style&index=0&id=68e0a424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0a424",
  null
  
)

export default component.exports